import type { IValidatedResponse } from '../../httpClient';
import { patchRequest } from '../../httpClient';
import type { ISetSocialChannelStatusV1Request } from './set-social-channel-status-v1-request';
import type { ISetSocialChannelStatusV1Response } from './set-social-channel-status-v1-response';
import { setSocialChannelStatusV1ResponseSchema } from './set-social-channel-status-v1-response';

export async function setSocialChannelStatusV1Api({
  channelId,
  status,
}: ISetSocialChannelStatusV1Request): Promise<
  IValidatedResponse<ISetSocialChannelStatusV1Response>
> {
  return patchRequest<ISetSocialChannelStatusV1Response>({
    path: `/sys/social/v1/channels/${channelId}`,
    body: { status },
    schema: setSocialChannelStatusV1ResponseSchema,
  });
}
